import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { SummaryCard, SummaryCardLabel, SummaryCardsRow, SummaryCardValue } from './PointStyled';

// 계산식 힌트 — 백엔드 MemberPointHistoryRepository.sumPoint*: SUM(point) - SUM(canceledPoint), 기간 필터 미적용
const EARN_HINT = '지금까지 적립된 포인트 전체 합계예요. 지급 취소로 회수한 포인트는 빼고 계산해요. 날짜를 지정해도 바뀌지 않아요.';
const DEDUCT_HINT = '지금까지 사용·차감·소멸된 포인트 전체 합계예요. 차감 취소로 돌려준 포인트는 빼고 계산해요. 날짜를 지정해도 바뀌지 않아요.';

/**
 * 총 적립 포인트 / 총 차감 포인트 요약 카드
 * 회원상세 > 포인트 탭, 센터관리 > 포인트 관리에서 공용으로 사용.
 */
const PointSummaryCards = ({ totalEarnPoint = 0, totalDeductPoint = 0 }) => {
  const { t } = useTranslation();

  return (
    <SummaryCardsRow>
      <SummaryCard cardVariant="earn">
        <SummaryCardLabel cardVariant="earn">
          {t('총 적립 포인트')}
          <Tooltip title={EARN_HINT} arrow>
            <InfoOutlinedIcon sx={{ fontSize: '0.7em', ml: '4px', verticalAlign: 'middle', cursor: 'help' }} />
          </Tooltip>
        </SummaryCardLabel>
        <SummaryCardValue cardVariant="earn">+{Number(totalEarnPoint || 0).toLocaleString()} P</SummaryCardValue>
      </SummaryCard>
      <SummaryCard cardVariant="deduct">
        <SummaryCardLabel cardVariant="deduct">
          {t('총 차감 포인트')}
          <Tooltip title={DEDUCT_HINT} arrow>
            <InfoOutlinedIcon sx={{ fontSize: '0.7em', ml: '4px', verticalAlign: 'middle', cursor: 'help' }} />
          </Tooltip>
        </SummaryCardLabel>
        <SummaryCardValue cardVariant="deduct">-{Number(totalDeductPoint || 0).toLocaleString()} P</SummaryCardValue>
      </SummaryCard>
    </SummaryCardsRow>
  );
};

export default PointSummaryCards;
